import { Heading } from '@/components/ui/heading';
import { useClientTranslation } from '@/lib/core/i18n';
import { BookmarkButton } from '../ui/bookmark-button';
import { EyebrowTags } from '../ui/eyebrow-tags';
import { resolveHeadingLevel } from '../ui/heading-level';

interface IntroBlockProps {
  title?: string | null;
  titleHeading?: string | null;
  membersOnly?: boolean;
  serviceCategoryName?: string | null;
  address?: string | null;
  isBookmarked?: boolean;
  onBookmark?: () => void;
}

export function IntroBlock({
  title,
  titleHeading,
  membersOnly,
  serviceCategoryName,
  address,
  isBookmarked,
  onBookmark,
}: IntroBlockProps) {
  const t = useClientTranslation();
  const headingAs = resolveHeadingLevel(titleHeading);

  return (
    <div className="flex flex-col gap-6 px-4 pt-8">
      {/* Tags + title + address */}
      <div className="flex flex-col gap-[10px]">
        {(membersOnly || serviceCategoryName) && (
          <EyebrowTags
            labels={[membersOnly ? t('App.Labels.MembersOnly') : null, serviceCategoryName]}
            trailing={onBookmark && <BookmarkButton isBookmarked={!!isBookmarked} onBookmark={onBookmark} />}
          />
        )}

        {title && (
          <Heading
            as={headingAs}
            className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[24px] leading-none font-semibold"
          >
            {title}
          </Heading>
        )}

        {address && (
          <p className="font-inter text-jncquoi-neutral-1000 text-[16px] leading-none font-semibold tracking-[0.25px]">
            {address}
          </p>
        )}
      </div>
    </div>
  );
}
